module.exports = (route) => {
  const routes = window.mubiRoutes || {};
  return routes[route];
};
